
import { AnnotationsViewer, useTitle } from "daymap-react"
import PageHeader from "../../../../containers/pageheader/pageheader"
import { PageContainer } from "../../../../components/layout"
import { useNavigate, useParams } from "react-router-dom"

function Annotations() {
    useTitle("Work Annotations");
    const navigate = useNavigate();
    const { fileId } = useParams();

    return <>
        <PageHeader 
            title="Feedback" 
            onBackButtonClick={() => navigate(-1)}
         />
        <PageContainer>
            <AnnotationsViewer fileId={Number(fileId)} />
        </PageContainer>
    </>
}

export default Annotations